import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { Check, ChevronDown } from "lucide-react";

export default function BrandSelect({ categoryId, value, onChange }) {
    const [brands, setBrands] = useState([]);
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        api.get("/category-brands", { params: categoryId ? { category_id: categoryId } : {} }).then(({ data }) => setBrands(data)).catch(() => setBrands([]));
    }, [categoryId]);
    useEffect(() => {
        const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
        document.addEventListener("mousedown", close);
        return () => document.removeEventListener("mousedown", close);
    }, []);

    if (!brands.length) return null;
    const current = brands.find((b) => b.id === value);
    const pick = (id) => { onChange(id); setOpen(false); };

    return (
        <div className="relative" ref={ref} data-testid="brand-select">
            <button type="button" onClick={() => setOpen((o) => !o)} data-testid="brand-select-toggle"
                className="inline-flex items-center justify-between gap-2 min-w-[180px] px-3 py-1.5 bg-[hsl(var(--primary))] text-white font-mono text-xs font-bold uppercase">
                {current ? current.name : "Brandet"}
                <ChevronDown className={`w-4 h-4 transition-transform ${open ? "rotate-180" : ""}`} />
            </button>
            {open && (
                <div className="absolute z-30 mt-1 w-64 bg-white border border-slate-200 shadow-xl max-h-72 overflow-y-auto" data-testid="brand-select-list">
                    <button onClick={() => pick("")} className="w-full flex items-center justify-between px-3 py-2 text-sm hover:bg-slate-50 border-b border-slate-100" data-testid="brand-select-all">
                        Të gjitha {!value && <Check className="w-4 h-4" />}
                    </button>
                    {brands.map((b) => (
                        <button key={b.id} onClick={() => pick(b.id)} data-testid={`brand-select-${b.id}`}
                            className={`w-full flex items-center gap-2 px-3 py-2 text-sm hover:bg-slate-50 ${b.id === value ? "font-bold" : ""}`}>
                            {b.logo_url && <img src={b.logo_url} alt="" className="w-5 h-5 object-contain" onError={(e) => { e.currentTarget.style.display = "none"; }} />}
                            <span className="flex-1 text-left truncate">{b.name}</span>
                            <span className="font-mono text-xs text-slate-400">{b.count}</span>
                            {b.id === value && <Check className="w-4 h-4" />}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}
